export default {
  VERSION: 2.1,
  TIMEZONE: "America/Los_Angeles",
  API_ENDPOINT: import.meta.env.EXPOSED_API_ENDPOINT,
};
